import "./App.css";
import StockSummary from "./pages/StockSummary";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const App: React.FC = () => {
	return (
		<div>
			<Router>
				<Switch>
					<Route path="/">
						<main className="App d-flex flex-column container">
							<StockSummary />
						</main>
					</Route>
				</Switch>
			</Router>
		</div>
	);
};

export default App;
